import { Tbl_giornataEdit } from './tbl_giornataEdit';
import { Tbl_giornataList } from './tbl_giornataList';
import { Tbl_giornataShow } from './tbl_giornataShow';
import { Tbl_giornataCreate } from './tbl_giornataCreate';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_giornataList,
    edit: Tbl_giornataEdit,
    show: Tbl_giornataShow,
    create: Tbl_giornataCreate,
    icon: CalendarTodayIcon
};
